module.exports = import("https://storage.googleapis.com/workbox-cdn/releases/7.3.0/workbox-window.prod.mjs");;